import { ALL_SPORTS } from '@sportninja/common/features/profile/stats/constants'

import ChipGroup from 'src/components/ts-components/ChipGroup'
import SportIcon from 'src/components/icons/SportIcon'

interface SportChipsProps {
  options: { value: string; label: string }[]
  value: string | null
  onChange: (sportKey: string) => void
}

/** Icon size inside a 32px chip — the button-icon contract. */
const SPORT_ICON_SIZE = 16

const SportChips = ({ options, value, onChange }: SportChipsProps) => {
  'use memo'

  // Each sport leads with its glyph; All Sports gets the generic one so the
  // row reads as a set. The label is the sport's display name, which is what
  // the icon mapping matches on.
  const chipOptions = options.map((option) => ({
    ...option,
    icon: (
      <SportIcon
        sportName={option.value === ALL_SPORTS ? null : option.label}
        size={SPORT_ICON_SIZE}
      />
    ),
  }))

  return (
    <ChipGroup
      options={chipOptions}
      value={value}
      onChange={onChange}
      ariaLabel='Sport'
    />
  )
}

export default SportChips
